import React from "react";

function Breadcrumb({ title, sub_title, active }) {
  return (
    <div>
      {/* Start Breadcrumb area */}
      <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
        <div className="overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inner text-center">
                <h1 className="title split-collab">{title}</h1>
                <ul className="page-list">
                  <li className="tmp-breadcrumb-item">
                    <a href="/">{sub_title}</a>
                  </li>
                  <li className="icon">
                    <i className="fa-solid fa-angle-right" />
                  </li>
                  <li className="tmp-breadcrumb-item active">{active}</li>
                </ul>
                <div className="circle-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumb area */}
    </div>
  );
}

export default Breadcrumb;
